export enum TYPES {
  SERVICES = "SERVICES",
  PACKAGES = "PACKAGES",
}
